import * as React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router';
import ERoute from '../../ERoute';
import ArticleItem from '../../components/Messenger/Help/ArticleItem';
import { connect } from 'react-redux';
import { AppState } from '../../store';
import { AnyAction, Dispatch } from 'redux';
import { HelpCenterState } from '../../store/help_center/types';
import { setHelpCenterState } from '../../store/help_center/actions';
import Loader from '../../../help_center/components/Loader/Loader';
import { useTranslation } from 'react-i18next';
import Button from '../Messenger/Button/Button';
import showdown from '../../../utilities/showdown';

const Container = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  background-color: white;
  z-index: 1;
  overflow-x: hidden;
  overflow-y: auto;
`

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;

  ${Loader} {

  }
`

const EmptyContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const EmptyTitle = styled.div`
  display: block;
  margin: 24px 0px 12px;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: rgb(28, 28, 28);
`

const EmptyDescription = styled.div`
  line-height: 21px;
  font-size: 14px;
  color: rgb(28, 28, 28);
  margin-bottom: 40px;
`

interface IStateToProps {
  helpCenterState: HelpCenterState
}

interface IDispatchToProps {
  setHelpCenterState: typeof setHelpCenterState
}


type IProps = IStateToProps & IDispatchToProps

const SearchResults = (props: IProps) => {
  const history = useHistory()
  const { t } = useTranslation()
  const {
    helpCenterState: {
      articles,
      isFetching,
      search
    }
  } = props

  if (search?.length === 0) return null
  if (isFetching) return null

  const onNewConversationClick = () => {
    history.push(ERoute.PATH_NEW_CONVERSATION)

  }

  return (
    <Container>
      {articles.length === 0 && <EmptyContainer>
        <EmptyTitle>{t('SearchResults::Try again')}</EmptyTitle>
        <EmptyDescription dangerouslySetInnerHTML={{ __html: showdown.makeHtml(t('SearchResults::No results for <b>\'{{search}}\'</b>', { search: search })) }} />

        <Button onClick={onNewConversationClick}>
          {t('SearchResults::Send us a message')}

          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fillRule="evenodd" d="m4.394 14.7 9.356-5.4c1-.577 1-2.02 0-2.598L4.394 1.299a1.5 1.5 0 0 0-2.25 1.3v3.438l4.059 1.088c.494.132.494.833 0 .966l-4.06 1.087v4.224a1.5 1.5 0 0 0 2.25 1.299" clipRule="evenodd"></path></svg>
        </Button>
      </EmptyContainer>}

      {articles?.map((article) => {
        return (
          <ArticleItem
            key={article.id}
            article={article}
          />
        )
      })}
    </Container>
  )
}

const mapStateToProps = (state: AppState): IStateToProps => {
  const {
    helpCenter: helpCenterState,
  } = state

  return {
    helpCenterState: helpCenterState,
  }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): IDispatchToProps => {
  return {
    setHelpCenterState: (options) => dispatch(setHelpCenterState(options)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchResults)